import { colors } from '@ardoq/design-tokens';
import { Icon, IconName } from '@ardoq/icons';
import { StatusType, Tag } from '@ardoq/status-ui';
import { FlexBox } from '@ardoq/layout';
import { ScheduleMeta } from '@ardoq/api-types';
import { Complaint } from '@ardoq/api-types/integrations';
import { complaintsToComplaintLevel } from 'integrations/common/streams/transferState/utils';
import { t, type WithI18nLocale } from '@ardoq/i18n';

type ScheduleStatusProps = ScheduleMeta & WithI18nLocale;

export const ScheduleStatus = ({ meta, i18nLocale }: ScheduleStatusProps) => {
  const defaultComplaints: Complaint[] =
    meta.lastResult?.status === 'error'
      ? [
          {
            level: 'error',
            messageKey: '',
            message:
              meta.lastResult.message ||
              t(
                i18nLocale,
                'integrations:scheduleStatus.unknownError',
                'Unknown error'
              ),
            target: 'sheet',
            tableId: '',
          } satisfies Complaint,
        ]
      : [];

  const allComplaints = [
    ...(meta.lastResult?.summary?.validation ?? []),
    ...defaultComplaints,
  ];

  const complaintLevel = complaintsToComplaintLevel(allComplaints);

  return (
    <FlexBox gap="small" align="center">
      {meta.paused ? (
        <Tag statusType={StatusType.WARNING}>
          {t(i18nLocale, 'integrations:scheduleStatus.paused', 'Paused')}
        </Tag>
      ) : (
        <Tag statusType={StatusType.INFO}>
          {t(i18nLocale, 'integrations:scheduleStatus.active', 'Active')}
        </Tag>
      )}
      {complaintLevel === 'Error' && (
        <Icon iconName={IconName.ERROR} style={{ color: colors.red600 }} />
      )}
      {complaintLevel === 'Warning' && (
        <Icon iconName={IconName.WARNING} style={{ color: colors.yellow600 }} />
      )}
    </FlexBox>
  );
};
